export const withDefaultProps = <Props> (defaultProps: Partial<Props>, componentFactory: (props: Props) => any): React.FC<Props> => {
	const component = (props: Props) => componentFactory(props);
	component.defaultProps = defaultProps;
	return component;
}